import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "@/contexts/AuthContext";
import { useVersionCheck } from "@/hooks/useVersionCheck";
import UpdateAvailableModal from "@/components/feature/UpdateAvailableModal";

function App() {
    const { hasUpdate, applyUpdate } = useVersionCheck();

    return (
        <I18nextProvider i18n={i18n}>
            <AuthProvider>
                <BrowserRouter basename={__BASE_PATH__}>
                    <AppRoutes />
                </BrowserRouter>
                {hasUpdate && <UpdateAvailableModal onUpdate={applyUpdate} />}
            </AuthProvider>
        </I18nextProvider>
    );
}

export default App;
